// extracted by mini-css-extract-plugin
export var pillWrapper = "_ob-0";
export var showOverflow = "_ob-1";